import { render, staticRenderFns } from "./MenuFrame.vue?vue&type=template&id=535dc38e&"
import script from "./MenuFrame.vue?vue&type=script&lang=js&"
export * from "./MenuFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports